import React, { useEffect, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../_redux/access-role/accessRoleAction';
import * as uiHelpers from '../AccessRoleUIHelpers';

import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage,
} from '../../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';
import { Pagination } from '../../../../../../_metronic/_partials/controls';
import { useAccessRoleUIContext } from '../AccessRoleUIContext';
import { RoleChecker } from '../../../../../RoleChecker';
// import { ToastContainer } from 'react-toastify';

const AccessRoleTable = (props) => {
    // AccessRole UI Context
    const accessRoleUIContext = useAccessRoleUIContext();
    const accessRoleUIProps = useMemo(() => {
        return {
            queryParams: accessRoleUIContext.queryParams,
            setQueryParams: accessRoleUIContext.setQueryParams,
            openEditAccessRolePage: accessRoleUIContext.openEditAccessRolePage,
        };
    }, [accessRoleUIContext]);


    // Getting curret state of accessRole list from store (Redux)
    const { currentState } = useSelector(
        (state) => ({ currentState: state.accessRoles }),
        shallowEqual,
    );

    const { totalCount, entities, listLoading } = currentState;

    const dispatch = useDispatch();
    useEffect(() => {

        //Requset ke Branch Action
        dispatch(actions.fetchAccessRoles(accessRoleUIProps.queryParams));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessRoleUIProps.queryParams, dispatch]);

    const allowEdit = RoleChecker('Edit', 'access_role')

    // Table columns
    const columns = [
        {
            dataField: 'name',
            text: 'Nama',
            sort: true,
            // sortCaret: sortCaret,
        },
        {
            dataField: 'action',
            text: 'Actions',
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditAccessRolePage: accessRoleUIProps.openEditAccessRolePage,
                allowEdit
            },
            classes: 'text-right pr-0',
            headerClasses: 'text-right pr-3',
            style: {
                minWidth: '100px',
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: accessRoleUIProps.queryParams.pageSize,
        page: accessRoleUIProps.queryParams.pageNumber,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination
                            isLoading={listLoading}
                            paginationProps={paginationProps}
                        >
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                bordered={false}
                                remote
                                keyField="uuid"
                                data={entities === null ? [] : entities}
                                columns={columns}
                                // defaultSorted={uiHelpers.defaultSorted}
                                onTableChange={getHandlerTableChange(
                                    accessRoleUIProps.setQueryParams,
                                )}
                                // selectRow={getSelectRow({
                                //   entities,
                                //   ids: productsUIProps.ids,
                                //   setIds: productsUIProps.setIds,
                                // })}
                                {...paginationTableProps}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
        </>
    );
};

export default AccessRoleTable;
